var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.style),attrs:{"src":require('@/assets/images/' + _vm.source)}})
}
var staticRenderFns = []

export { render, staticRenderFns }